window.addEventListener("DOMContentLoaded", function() { 

    if(Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
            if (e.target.dataset.shopifyEditorSection.includes('footer')) {
                let footerSelector = document.querySelectorAll('.footerSelector')
                if(footerSelector) {
                    footerSelector.forEach(el => {
                        el.addEventListener('click', navigateCustomSelect);
                        el.addEventListener('keydown', navigateCustomSelect);
                    })
                }
            }
        })
    }

    // Hide/show controls
    let formDisplayBtn = document.querySelectorAll('.formDisplayBtn');
    let deleteAddressBtns = document.querySelectorAll('.addressDeleteBtns')
    let deleteForm = document.querySelector('#deleteFrom')

    for (let i = 0; i < formDisplayBtn.length; i++) {
        formDisplayBtn[i].addEventListener('click', formDisplay)
    }

    deleteAddressBtns.forEach(btn => {
        btn.addEventListener('click', deleteAddress)
    })

    function formDisplay(e) {
        document.getElementById(e.currentTarget.dataset.formId).classList.toggle('displayNone')
    }

    
    function deleteAddress (e) {
        let id = e.currentTarget.dataset.addressId
        deleteForm.action = `/account/addresses/${id}`
        if (window.confirm(deleteForm.dataset.deleteMessage)) {
            deleteForm.submit()
        }
    }

    // Custom select 
    let customSelectWrap = document.querySelectorAll('.customSelectWrap')

    document.addEventListener('click', (e) => {
        for (let i = 0; i < customSelectWrap.length; i++) {
            if (e.target != customSelectWrap[i]){
                customSelectWrap[i].children[1].classList.add('displayNone')
            }
        }
    })

    for (let i = 0; i < customSelectWrap.length; i++) {
        if (customSelectWrap[i].classList.contains('customSelectWrapToFill')) {
            populateCustomSelect(customSelectWrap[i].children[1].children[0])
        }
    } 

    function populateCustomSelect(customSelectInnerWrap){
        for (let i = 0; i < customSelectInnerWrap.parentElement.parentElement.previousElementSibling.options.length; i++) {
            let span = document.createElement('span')
            span.setAttribute('tabIndex', 0)
            span.setAttribute('role', 'listitem')
            span.innerText = customSelectInnerWrap.parentElement.parentElement.previousElementSibling.options[i].innerText
            customSelectInnerWrap.append(span)
        }
    } 


    for (let i = 0; i < customSelectWrap.length; i++) {
        customSelectWrap[i].addEventListener('click', navigateCustomSelect);
        customSelectWrap[i].addEventListener('keydown', navigateCustomSelect);
    
        if (customSelectWrap[i].classList.contains('customSelectWrapToFill')) {
            if (customSelectWrap[i].children[0].innerText.length == 0) {
                customSelectWrap[i].children[0].innerText = customSelectWrap[i].previousElementSibling.options[0].text 
            } else {
                for(let j = 0; j < customSelectWrap[i].children[1].children[0].children.length; j++){
                    if (customSelectWrap[i].children[0].innerText == customSelectWrap[i].children[1].children[0].children[j].innerText) {
                        customSelectWrap[i].dataset.index = j
                        updateFormSelect(customSelectWrap[i], j, true)
                    }
                }
            }
        }

    }


    function populateProvincies(realSelect, index, initialPageLoad) {
        let provinces = []
        if (realSelect.children[index].dataset.provinces) {
            provinces = JSON.parse(realSelect.children[index].dataset.provinces)
        }



        let fieldParent = realSelect.parentElement
        let provinciesParent = fieldParent.nextElementSibling 

        let provinciesSelect = provinciesParent.children[1]
        let customProvinciesWrap =  provinciesParent.children[2]

        let customProvinciesWrapCurrent = customProvinciesWrap.children[0]
        let  customProvinciesWrapList = customProvinciesWrap.children[1].children[0]

        customProvinciesWrapList.innerHTML = ''
        provinciesSelect.innerHTML = ''
        if(!initialPageLoad) {
            customProvinciesWrapCurrent.innerText = ''
        }


        provinciesParent.classList.add('displayNone')



        if (provinces.length > 0) {

            for (let i = 0; i < provinces.length; i++) {
                let prov = provinces[i][0]
                
                let span = document.createElement('span')
                let option = document.createElement('option')
                span.setAttribute('tabIndex', 0)
                span.setAttribute('role', 'listitem')
                span.innerText = prov
                option.innerText = prov
                customProvinciesWrapList.append(span)
                provinciesSelect.appendChild(option)
            }

            provinciesParent.classList.remove('displayNone')
            customProvinciesWrap.dataset.index = "false"
            if (customProvinciesWrapCurrent.innerText.length == 0) {
                customProvinciesWrapCurrent.innerText = provinciesSelect.children[0].innerText 
            } else {
                for (let i = 0; i < provinciesSelect.children.length; i++) {
                    if (customProvinciesWrapCurrent.innerText == provinciesSelect.children[i].innerText) {
                        provinciesSelect.selectedIndex = i
                        customProvinciesWrapCurrent.innerText = provinciesSelect.children[i].innerText
                        break
                    }
                }
            }
        }
    }

    function updateFormSelect(customSelectWrap, index, initialPageLoad) {
        if(customSelectWrap.classList.contains('footerSelector')) { return }
        let realSelect = customSelectWrap.previousElementSibling 
        realSelect.selectedIndex = index

        if (customSelectWrap.classList.contains('customSelectWrapToFill')) {
            populateProvincies(realSelect, index, initialPageLoad)
        }
    }

    function navigateCustomSelect(e) {
        let customSelectWrap = e.currentTarget
        let currentValueSelected = e.currentTarget.children[0]
        let currentOptionIndex = e.currentTarget.dataset.index
        let customOptionsListWrap = e.currentTarget.children[1]
        let customOptionsList = e.currentTarget.children[1].children[0]


            if (e.key != "Tab") {
                e.preventDefault()
            }

            if (e.key == "Tab" && !customOptionsListWrap.classList.contains('displayNone')) {
                customOptionsListWrap.classList.add('displayNone')
            }
            
            if (customSelectWrap.dataset.index == "false") {
                for(let i = 0; i < customOptionsList.children.length; i++) {
                    if (currentValueSelected.innerText == customOptionsList.children[i].innerText) {
                        customSelectWrap.dataset.index = i
                        currentOptionIndex = i
                        break
                    }
                } 
            } 

            if (e.type == 'click' || (e.type == 'keydown' && e.key == 'Enter')) {
                if (!customOptionsListWrap.classList.contains('displayNone')) {
                    customOptionsListWrap.classList.add('displayNone')
                    if (customOptionsList.children[currentOptionIndex].innerText != currentValueSelected.innerText) {
                        handleLocalization(customOptionsList.children[currentOptionIndex].dataset.code, customSelectWrap)
                    }
                    customSelectWrap.focus()                        
                } else {
                    customOptionsListWrap.classList.remove('displayNone')
                    customOptionsList.children[currentOptionIndex].focus()              
                    customOptionsList.children[currentOptionIndex].setAttribute('aria-selected', true)
                }
            }

            if (e.key == 'ArrowUp' && currentOptionIndex > 0) {
                if(customSelectWrap.classList.contains('footerSelector') && customOptionsListWrap.classList.contains('displayNone')) { return }
                customOptionsList.children[currentOptionIndex].removeAttribute('aria-selected')
                currentOptionIndex --
                customSelectWrap.dataset.index = currentOptionIndex
                customOptionsList.children[currentOptionIndex].focus()
                currentValueSelected.innerText = customOptionsList.children[currentOptionIndex].innerText
                updateFormSelect(customSelectWrap, currentOptionIndex, false)
                customOptionsList.children[currentOptionIndex].setAttribute('aria-selected', true)
            } else if (e.key == 'ArrowDown' && currentOptionIndex < customOptionsList.children.length - 1) {
                if(customSelectWrap.classList.contains('footerSelector') && customOptionsListWrap.classList.contains('displayNone')) { return }
                customOptionsList.children[currentOptionIndex].removeAttribute('aria-selected')
                currentOptionIndex ++
                customSelectWrap.dataset.index = currentOptionIndex
                customOptionsList.children[currentOptionIndex].focus()
                currentValueSelected.innerText = customOptionsList.children[currentOptionIndex].innerText
                updateFormSelect(customSelectWrap, currentOptionIndex, false)
                customOptionsList.children[currentOptionIndex].setAttribute('aria-selected', true)
            } 


            if (e.type == 'click' && e.target.nodeName == "SPAN") {
                customOptionsList.children[currentOptionIndex].removeAttribute('aria-selected')
                for (let i = 0; i < customOptionsList.children.length; i++) {
                    if (customOptionsList.children[i].innerText == e.target.innerText) {
                        customSelectWrap.dataset.index = i
                        currentValueSelected.innerText = customOptionsList.children[i].innerText
                        customOptionsList.children[i].setAttribute('aria-selected', true)
                        handleLocalization(customOptionsList.children[i].dataset.code, customSelectWrap)
                        updateFormSelect(customSelectWrap, i, false)
                        break
                    }
                }

            }
    }

    function handleLocalization(code, el) {
        if (el.classList.contains('languageSelect')) {
            let inp = document.querySelector('#languageFormInput')
            inp.value = code
            inp.parentElement.submit()
        } else if (el.classList.contains('countrySelect')) {
            let inp = document.querySelector('#countryFormInput')
            inp.value = code
            inp.parentElement.submit()
        }
    }

    let customCheckBoxes = document.querySelectorAll('.customCheckboxWrapAccounts');

    customCheckBoxes.forEach(checkbox => {
        if (checkbox.dataset.isChecked == "true") {
            checkbox.querySelector('.customCheckboxSvg').classList.remove('displayNone')
        }
        checkbox.addEventListener('click', handleCheckboxes)
    })

    function handleCheckboxes(e) {
        let checkboxWrap = e.currentTarget
        
        if(checkboxWrap.dataset.isDisabled){ e.stopImmediatePropagation(); return }
        
        let realcheckbox = checkboxWrap.querySelector('input')  
        checkboxWrap.querySelector('.customCheckboxSvg').classList.toggle('displayNone') 
        
        if (checkboxWrap.querySelector('.customCheckboxSvg').classList.contains('displayNone')) {
            if (realcheckbox) {realcheckbox.checked = false}
            checkboxWrap.dataset.isChecked = "false" 
        } else {
            if (realcheckbox) {realcheckbox.checked = true}
            checkboxWrap.dataset.isChecked = "true" 
        }
        
    }

    const labelForCustomSelect = document.querySelectorAll('.labelForCustomSelect')

    labelForCustomSelect.forEach(label => {
        label.addEventListener('click', (e) => {
            let forAttr = e.currentTarget.getAttribute('for')
            document.querySelector(`div[data-for="${forAttr}"]`).focus()
        })
    })



});
